export default {
    www: 'https://www.splashtop.com',
    linkTracker: '?sos=1',
    winDownload: 'https://download.splashtop.com/sos/SplashtopSOS.exe',
    macDownload: 'https://download.splashtop.com/sos/SplashtopSOS.dmg',
    androidDownload: 'https://play.google.com/store/apps/details?id=com.splashtop.sos',
    androidAPK: 'https://download.splashtop.com/sos/SplashtopSOS.apk',
    androidVideo: 'https://www.youtube.com/embed/th8G_EVeZAY?autoplay=1&rel=0',
    iosDownload: 'https://apps.apple.com/app/splashtop-sos/id1230853703',
    iosVideo: 'https://www.youtube.com/embed/KmZmeaBenCI?autoplay=1&rel=0',
    freeTrial: 'https://www.splashtop.com/free-trial?sos=1',
    freeTrialEU: 'https://www.splashtop.com/free-trial?sos=1',
    winDownloadEU: 'https://download.splashtop.com/sos/eu/SplashtopSOS.exe',
    macDownloadEU: 'https://download.splashtop.com/sos/eu/SplashtopSOS.dmg',
    winDownloadOC: 'https://download.splashtop.com/sos/oc/SplashtopSOS.exe',
    macDownloadOC: 'https://download.splashtop.com/sos/oc/SplashtopSOS.dmg',
    winDownloadCN: 'https://download.splashtop.cn/sos/SplashtopSOS.exe',
    macDownloadCN: 'https://download.splashtop.cn/sos/SplashtopSOS.dmg',
    iosDownloadCN: 'https://apps.apple.com/cn/app/splashtop-sos/id1230853703',
    androidDownloadCN: 'https://download.splashtop.cn/sos/SplashtopSOS.apk',
    termLink: 'terms/splashtop'
}